// src/com/sms_message/SmsMessageGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * SMS_MESSAGE Apollo Graphql
 * SMS 전송 기록
 * Project: NewTOP for cloud
 * 2025-01-24 11:19:14 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const SMS_MESSAGE_LIST_PART = gql`
fragment SmsMessageListPart on SmsMessage {
    smsMessageSeq
    comId
    custId
    userId
    message
    forTop
    seperateCnt
    recvTel
    callTel
    regUser
    regDate
    userName
    comName
}
`;

/* const SMS_MESSAGE_NO_LIST_PART = gql`
fragment SmsMessageNoListPart on SmsMessage {
}
`; */


//smsMessageList(dateFrom:String!, dateTill:String!): [SmsMessage]!
export const LIST_SMS_MESSAGE = gql`
${SMS_MESSAGE_LIST_PART}
query ListSmsMessage($dateFrom:String!, $dateTill:String!) {
    smsMessageList(dateFrom:$dateFrom, dateTill:$dateTill) {
        ...SmsMessageListPart
    }
}
`;

/* export const GET_SMS_MESSAGE = gql`
${SMS_MESSAGE_LIST_PART}
${SMS_MESSAGE_NO_LIST_PART}
query GetSmsMessage($smsMessageSeq:Int!) {
    smsMessageItem(smsMessageSeq:$smsMessageSeq) {
        ...SmsMessageListPart
        ...SmsMessageNoListPart
    }
}
`; */

export const ADD_SMS_MESSAGE = gql`
mutation AddSmsMessage($smsMessage:InputSmsMessageAdd!) {
	smsMessageAdd(smsMessage: $smsMessage) {
		ok
		message
	}
}
`;


